export const WORK_STATUS = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  PENDING_CHANGES: "PENDING_CHANGES",
  PUBLISHED: "PUBLISHED",
  REJECTED: "REJECTED",
};
